import API from "../api";
export function toAbsoluteUrl(u) {
  if (!u) return u;
  if (/^https?:\/\//i.test(u)) return u;
  // u = "/static/…"
  const base = API.defaults.baseURL?.replace(/\/+$/, "") || "";
  return `${base}${u}`;
}
